module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "primeira-via"
  }, [_c('impresso', {
    attrs: {
      "via": "1",
      "destino": "DRH",
      "nomeServidor": _vm.nomeFuncionario,
      "servidor": _vm.funcionario,
      "dataSolicitada": _vm.dataSolicitacao,
      "dataDaFalta": _vm.dataFalta,
      "mostraDataSolicitada": _vm.mostraInputSolicitacao,
      "mostraDataFalta": _vm.mostraInputFalta
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "segunda-via"
  }, [_c('impresso', {
    attrs: {
      "via": "2",
      "destino": "Solicitante",
      "nomeServidor": _vm.nomeFuncionario,
      "servidor": _vm.funcionario,
      "dataSolicitada": _vm.dataSolicitacao,
      "dataDaFalta": _vm.dataFalta,
      "mostraDataSolicitada": _vm.mostraInputSolicitacao,
      "mostraDataFalta": _vm.mostraInputFalta
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3218d0a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/falta-lei/pagina-impresso.vue
// module id = 3B2p
// module chunks = 5